import React, { useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { AvForm } from "availity-reactstrap-validation";

import { messages, EMPTY_STRING } from "../../../../constants";
import { ReactComponent as BackIcon } from "../../../../assets/icons/back.svg";
import RichTextEditor from "../../../../shared/components/Editor/RichTextEditor";
import { capitalizeWords } from "../../../../shared";

const AiSummaryRecap = (props) => {
  const {
    currentRecaps,
    handleGoBack,
    currentContent,
    handleBriefChange,
    handleValidSubmit,
    generateEditBrief,
    setCurrentContent,
    isAddFlow,
  } = props;

  const { t } = useTranslation("common");

  // Memoized Markdown parsing for initial content
  const initialContent = useMemo(() => {
    const list = currentRecaps || [];
    return isAddFlow
      ? list.filter((content) => content?.isAddFlowReel === true)
      : list.filter((content) => content?.description != null);
  }, [currentRecaps, isAddFlow]);
  // Memoized content change handler
  const handleContentChange = useCallback(
    (value, index) => {
      setCurrentContent((prev) => {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          description: value,
        };
        return updated;
      });
    },
    [setCurrentContent]
  );

  // Memoized blur handler
  const handleOnBlur = useCallback(
    (index) => {
      handleBriefChange(currentContent[index], index);
    },
    [currentContent, handleBriefChange]
  );

  return (
    <div className="ai-summary-recap col-12 p-4">
      <AvForm
        key="recap-brief-form"
        onValidSubmit={handleValidSubmit}
        autoComplete="off"
      >
        <div className="mt-3">
          <h4 className="label-content-600">
            based on your collected information, here is the editing brief for
            our shutterbz to help bring your event recap to life
          </h4>
          <div className="d-flex justify-content-center justify-content-sm-end">
            <button
              type="button"
              className="button-common button-fill mb-2"
              onClick={() => generateEditBrief()}
            >
              regenerate
            </button>
          </div>
          {initialContent?.map((content, index) => (
            <div key={index} className="mb-4">
              <div className="ai-summary-recap-title mb-2">
                {capitalizeWords(content?.eventName ?? EMPTY_STRING)}
              </div>
              <RichTextEditor
                initialContent={content?.description ?? EMPTY_STRING}
                onContentChange={(value) => handleContentChange(value, index)}
                onBlur={() => handleOnBlur(index)}
              />
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-center sticky-button-row mt-4">
          <button
            type="button"
            className="event-back-btn button-common button-outline btn-text-grey width-50"
            onClick={handleGoBack}
          >
            <BackIcon />
            <span className="pl-1">{t("go_back")}</span>
          </button>
          <button
            type="submit"
            className="button-common button-fill width-50 ml-3"
          >
            {messages.CONTINUE}
          </button>
        </div>
      </AvForm>
    </div>
  );
};

export default AiSummaryRecap;
